export const LEARN_MORE_LINK = 'https://wix.to/YASTRGa';
